import { useCreatePath } from 'react-admin';
import { useRegisterBreadcrumb } from '../layout/navbar/BreadcrumbsManager';
import resourceNames from '../../constants/resourceNames';

const MemberListBreadcrumb = () => {
  const createPath = useCreatePath();
  const path = createPath({ resource: resourceNames.MEMBERS, type: 'list' });
  useRegisterBreadcrumb({
    title: 'Members',
    path,
  });

  return null;
};

export default MemberListBreadcrumb;
